import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CORE_BASIC_SERVICE_URI } from 'library-@/config/apiConfig';
import type { ApiSendAdviceRequest, ApiSendAdviceResponse, SendAdvice } from './interface/send-advice.interface';

export const AdviceApiService = Symbol('AdviceApiService');

export type AdviceApiService = PsHttpService;

@injectable()
export class AdviceApiServiceImpl extends PsHttpService
    implements
    SendAdvice
{
    get options() {
        return {
            baseURL: CORE_BASIC_SERVICE_URI,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async sendAdvice(data: ApiSendAdviceRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiSendAdviceResponse>>({
            url: '/core-copilot-api/analytics/copilot/feedback',
            data,
            transformCode: true,
        });
        return res.data;
    }
}
